module.exports = __webpack_public_path__ + "img/exhibit-uploader.0c1ac62c.png";